module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p34"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rp34"
    }
  }, [_vm._v("CREAM OF BROCCOLI SOUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line-3.jpg",
      "width": "532"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "imagela"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/45.jpg",
      "width": "22"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('i', [_vm._v("Eat broccoli often—it’s high in antioxidants and packed with nutrients.")])])]), _vm._v(" "), _c('p', {
    staticClass: "make"
  }, [_c('span', [_vm._v("6 first-course servings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 cup chopped onion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("3 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 pounds broccoli, cut into pieces (2-inch)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ teaspoon dried thyme leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("⅛ teaspoon ground nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("3½ cups reduced-sodium fat-free chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ cup fat-free half-and-half or fat-free milk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Salt and white pepper, to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("6 tablespoons fat-free sour cream")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1½ cups Croutons (½ recipe) (see "), _c('span', {
    attrs: {
      "href": "#/Chapter131#p849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 636")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('b', [_vm._v("1.")]), _vm._v(" Sauté onion and garlic in lightly greased large saucepan until tender, 3 to 5 minutes. Stir in broccoli, thyme, and nutmeg; cook 2 minutes. Add broth to saucepan and heat to boiling; reduce heat and simmer, covered, until broccoli is tender, about 10 minutes. Stir in half-and-half. Process soup in food processor or blender until smooth; season to taste with salt and white pepper. Serve warm or chilled; stir 1 tablespoon sour cream into each bowl of soup and sprinkle with Croutons.")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Per Serving:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Calories: 99")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("% calories from fat: 9")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Protein (g): 6.8")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Carbohydrate (g): 17.6")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat (g): 1.1")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Saturated fat (g): 0.2")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Cholesterol (mg): 0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Sodium (mg): 110")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Exchanges:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Milk: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Vegetable: 2.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fruit: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Bread: 0.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Meat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("VARIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala",
    attrs: {
      "id": "p34a"
    }
  }, [_c('span', [_c('b', [_vm._v("Dilled Broccoli Soup")]), _vm._v(" — Make recipe as above, deleting thyme, nutmeg, and Croutons. Add ⅔ cup loosely packed fresh dill weed to soup when puréeing.")])]), _vm._v(" "), _c('p', {
    staticClass: "normala",
    attrs: {
      "id": "p34b"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('b', [_vm._v("Broccoli-Kale Soup")]), _vm._v(" — Make recipe as above, increasing broth to 5 cups and deleting the half-and-half, Croutons, and nutmeg. Stir 2 cups lightly packed kale into the soup during the last 5 minutes of cooking time. Add more broth if needed for desired consistency.")])]), _vm._v(" "), _c('p', {
    staticClass: "normala",
    attrs: {
      "id": "p34c"
    }
  }, [_c('span', [_c('b', [_vm._v("Cream of Asparagus Soup")]), _vm._v(" — Make soup as above, substituting 2 pounds asparagus for the broccoli, and reserving 18 small asparagus tips for garnish. Omit thyme leaves. Add 1 teaspoon dried marjoram leaves and 1 teaspoon grated lemon zest. Steam reserved asparagus tips until crisp-tender, and use to garnish soup.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5cf0d5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter0216.vue
// module id = 183
// module chunks = 0